import { getApiRoot } from "./getApiRoot";

export abstract class Constants {
    public static readonly ApiRoot = getApiRoot();
    public static readonly DiscordLink = "https://discord.gg/NkfgvRN";
    public static readonly MailToLink = "mailto:humans@gocoder.one";
    public static readonly TwitterLink = "https://twitter.com/coderonehq";
    public static readonly PrivacyLink = "https://coderone.notion.site/Privacy-Policy-f81ba14d345243d2a8859c72541ca27e";
    public static readonly BomberlandBlogLink = "/blog/bomberland-multi-agent-artificial-intelligence-competition";
    public static readonly TwitchLink = "https://twitch.tv/CoderOneHQ";
    public static readonly GithubLink = "https://github.com/CoderOneHQ";
    public static readonly GithubIssuesLink = "https://github.com/CoderOneHQ/bomberland/issues";
    public static readonly ContributeStarterKit = "https://github.com/CoderOneHQ/bomberland#contributing";
    public static readonly BomberlandStarterKits = "https://github.com/CoderOneHQ/bomberland#starter-kits";
    public static readonly BomberlandRepo = "https://github.com/CoderOneHQ/bomberland";
    public static readonly FeedbackForm = "https://coderone.typeform.com/to/DiXoxd1l#t=";
    public static readonly WaitlistForm = "https://coderone.typeform.com/to/s0zrbLTk";
    public static readonly DiscordSupportLink = "https://discord.gg/MKp2r28Vm9";
    public static readonly AISportsChallengeLink = "/aisports";
    public static readonly JobBoardBlog = "https://coderone.pallet.com/jobs?ref=blog";
    public static readonly JobBoardFooter = "https://coderone.pallet.com/jobs?ref=footer";
    public static readonly JobBoardNavbar = "https://coderone.pallet.com/jobs?ref=nav";
    public static readonly JobBoardSidebar = "https://coderone.pallet.com/jobs?ref=sidebar";
    public static readonly CollectiveBanner = "https://coderone.pallet.com/talent/welcome?referral=true&ref=banner";
    public static readonly SponsorshipEmail = "mailto:sponsorship@gocoder.one";
    public static readonly GithubContributions = "https://github.com/CoderOneHQ/bomberland/blob/master/CONTRIBUTING.md";
    public static readonly Season4BlogLink = "/blog/welcome-to-coder-one";
    public static readonly GeneralAssemblyLink = "https://ga.co/coderone22";
    public static readonly SitePointLink = "https://www.sitepoint.com/";
    public static readonly HackAusLink = "https://www.hackathonsaustralia.com/";
    public static readonly DSAiLink = "https://dsai.org.au/";
    public static readonly StudentClubPage = "https://bit.ly/coder-one-students";
    public static readonly SponsorshipForm = "https://coderone.typeform.com/to/I2hLDxCP";
    public static readonly CompetitionRules = "https://neon.ly/coder-one-2022-rules";
    public static readonly BomberlandTutorial = "/blog/ai-programming-tutorial-bomberman";
    public static readonly HajoBomberlandTutorial =
        "https://hajo.me/blog/2022/05/12/coder-one-bomberland-tutorial-1of3-introduction-replays-and-conversion-to-tensorflow/";
}
